import React, { useEffect, useState } from "react";
import { getDatabase, ref, onValue } from "firebase/database";
import { auth } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";
import { FaClock, FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { toast } from "react-toastify";

const OrderStatus = () => {
    const [orders, setOrders] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                fetchOrders(user.uid); // Jika pengguna login, ambil data pesanan
            } else {
                toast.error("Anda harus login untuk melihat status pesanan.");
                setIsLoading(false);
            }
        });

        // Membersihkan listener saat komponen dilepas
        return () => unsubscribe();
    }, []);

    // Fungsi mengambil data pesanan dari database
    const fetchOrders = (uid) => {
        const db = getDatabase();
        const ordersRef = ref(db, `orders/${uid}`);

        onValue(
            ordersRef,
            (snapshot) => {
                const data = snapshot.val();
                if (data) {
                    const orderList = Object.keys(data).map((key) => ({
                        id: key,
                        ...data[key]
                    }));
                    setOrders(orderList.reverse());
                } else {
                    setOrders([]);
                }
                setIsLoading(false);
            },
            (error) => {
                console.error("Error mengambil data pesanan:", error);
                toast.error("Gagal mengambil data pesanan.");
                setIsLoading(false);
            }
        );
    };

    const formatDate = (timestamp) => {
        const date = new Date(timestamp);
        return date.toLocaleString("id-ID", {
            day: "2-digit",
            month: "long",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit"
        });
    };

    return (
        <div className="container mx-auto p-4">
            <h1 className="text-2xl font-bold mb-4">Cek Status Pesanan</h1>

            {isLoading ? (
                <p>Memuat data pesanan...</p>
            ) : orders.length === 0 ? (
                <p>Tidak ada data pesanan.</p>
            ) : (
                <div className="overflow-x-auto">
                    <table className="table w-full border">
                        <thead>
                            <tr className="bg-gray-100">
                                <th>ID</th>
                                <th>Tanggal</th>
                                <th>Total Harga (Rp)</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {orders.map((order) => (
                                <tr key={order.id} className="border-b">
                                    <td>{order.id}</td>
                                    <td>{formatDate(order.date)}</td>
                                    <td>
                                        Rp{" "}
                                        {parseFloat(
                                            order.totalPrice
                                        ).toLocaleString("id-ID")}
                                    </td>
                                    <td>
                                        {order.status === "pending" ? (
                                            <span className="flex items-center text-yellow-500">
                                                <FaClock className="mr-1" />
                                                Pending
                                            </span>
                                        ) : order.status === "success" ? (
                                            <span className="flex items-center text-green-500">
                                                <FaCheckCircle className="mr-1" />
                                                Success
                                            </span>
                                        ) : (
                                            <span className="flex items-center text-red-500">
                                                <FaTimesCircle className="mr-1" />
                                                Ditolak
                                            </span>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default OrderStatus;
